var map = {
	"./assets/aok.svg": "./src/assets/aok.svg",
	"./assets/aok_favicon.ico": "./src/assets/aok_favicon.ico",
	"./assets/aok_mobile.svg": "./src/assets/aok_mobile.svg",
	"./assets/fr_favicon.ico": "./src/assets/fr_favicon.ico",
	"./assets/logoFraunhoferWhite.png": "./src/assets/logoFraunhoferWhite.png",
	"./assets/logoOrbis.png": "./src/assets/logoOrbis.png",
	"./assets/orbis-logo.png": "./src/assets/orbis-logo.png",
	"./assets/orbis_favicon.ico": "./src/assets/orbis_favicon.ico"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src sync recursive ^\\.\\/assets.*$";